import useSWR from 'swr'
import { CustomerAPI, CustomerFetcher } from '../../apis/CustomerAPI'
import MyAccountWrapper from '../../components/MyAccountWrapper'

import UserUploadsComponent from '../../components/UserUploadsComponent'

/**
 * @TODO
 * - Upload Files to AWS s3 - done
 * - Associate Files to users in the database - done
 * - Display Files in the UI - Done
 * - Remove File and delete from AWS s3 - done
 *
 * @SHOULD
 *  - should we use FormData to upload file to s3?
 */

function Uploads() {
    // const [
    //     page,
    //     perPage,
    //     totalPages,
    //     totalResults,
    //     setCurrentPage,
    //     setHeaders,
    // ] = usePagination({})

    const { data: customer, error } = useSWR(
        CustomerAPI.getCustomer,
        CustomerFetcher,
    )

    return (
        <MyAccountWrapper
            title={'Your Uploads'}
            error={error}
            description="Uploads allow you to save logos, headshots, signatures, customer designs, and other branding assets to use for future orders!">
            {error ? (
                'Failed to Load'
            ) : customer ? (
                <div className="md:flex w-full md:space-x-4 space-y-4 md:space-y-0">
                    <UserUploadsComponent
                        canDelete={true}
                        canUpload={true}
                        customer={customer}
                        isUploadsPage={true}
                    />
                </div>
            ) : (
                'Loading...'
            )}
        </MyAccountWrapper>
    )
}

export default Uploads
